module.exports = __webpack_public_path__ + "img/loading.1df8df97.gif";